var _circle, _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#393C46",
    fillOpacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3327 18.6666H35.3327V15.3333H28.666V18.6666H23.666V48.6666H40.3327V18.6666Z",
    fill: "#61656E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.076 42.4164C30.833 42.4164 30.6455 42.1151 30.6802 41.7748L31.3052 35.6109H28.8747C28.2635 35.6109 28.6455 34.8817 28.6594 34.8526C29.5344 32.6845 30.8469 29.4762 32.583 25.1984C32.6297 25.0861 32.7028 25.0001 32.7899 24.9549C32.8769 24.9097 32.9724 24.9083 33.0601 24.9507C33.1478 24.9932 33.2223 25.077 33.2708 25.1877C33.3193 25.2985 33.3388 25.4294 33.326 25.5581L32.701 31.722H35.1385C35.4163 31.722 35.5691 31.9067 35.4163 32.3637C33.1316 37.9442 31.8052 41.2012 31.4233 42.1345C31.3538 42.3095 31.2219 42.4164 31.076 42.4164Z",
    fill: "#1E2330"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.667,
    y: 47,
    width: 16.6667,
    height: 1.66667,
    fill: "#C75454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery0);
export default __webpack_public_path__ + "static/media/Battery-0.2cbad0399502d0218c2ab346cce11ae1.svg";
export { ForwardRef as ReactComponent };